export default __webpack_public_path__ + "static/media/404.b7d7f321.svg";